<agr-form-dialog [formGroup]="formGroup" [data]="data" (confirm)="confirm()" (cancel)="cancel()">
  <div>
    <mat-form-field class="full-width-field">
      <mat-label>{{ 'proprietaryFertilizer.name' | translate }}</mat-label>

      <input
        matInput
        formControlName="name"
        [placeholder]="'proprietaryFertilizer.name' | translate"
        data-test="proprietary-fertilizer-form__name"
      />
    </mat-form-field>
    <mat-form-field class="full-width-field">
      <mat-label>{{ 'proprietaryCustomerInformation.originalCropAid' | translate }}</mat-label>
      <input
        type="text"
        [placeholder]="'proprietaryCustomerInformation.originalCropAid' | translate"
        matInput
        formControlName="originalCropAidId"
        [matAutocomplete]="cropAidIdAutocomplete"
        data-test="proprietary-fertilizer-form__originalCropAidId"
        (blur)="checkOriginalCropAid()"
      />
      <mat-autocomplete #cropAidIdAutocomplete="matAutocomplete" [displayWith]="displayCropAid()">
        @for (option of filteredCropAids$ | async; track option) {
          <mat-option [value]="option.id">
            {{ option.name }}
          </mat-option>
        }
      </mat-autocomplete>
    </mat-form-field>
    <mat-form-field class="full-width-field">
      <mat-label>{{ 'expirationCropYear' | translate }}</mat-label>
      <mat-select
        formControlName="expirationCropYear"
        data-test="proprietary-fertilizer-form__expirationCropYear"
      >
        <mat-option [value]="0">({{ 'noLimit' | translate }})</mat-option>
        @for (expirationCropYear of expirationCropYears$ | async; track expirationCropYear) {
          <mat-option [value]="expirationCropYear">
            {{ expirationCropYear }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>
  <ng-container [formGroup]="nutritionalCompositionFormGroup">
    <h2 class="text--h3">{{ 'fertilizer.nutritionalComposition' | translate }}</h2>
    <div class="notification">
      <mat-icon>info</mat-icon>
      <div><b>Let op: % is kg per 100 kg</b></div>
    </div>
    <div>
      <mat-form-field>
        <mat-label>{{ 'nutritionalComposition.n' | translate }}</mat-label>
        <input
          matInput
          agrNumber
          [step]="0.001"
          placeholder="{{ 'nutritionalComposition.n' | translate }}"
          formControlName="n"
          data-test="proprietary-fertilizer-form__nutritionalComposition__n"
        />
        <span matSuffix class="form-field-suffix--text">%</span>
      </mat-form-field>
    </div>
    <div>
      <mat-form-field>
        <mat-label>{{ 'nutritionalComposition.p2O5' | translate }}</mat-label>
        <input
          matInput
          agrNumber
          [step]="0.001"
          placeholder="{{ 'nutritionalComposition.p2O5' | translate }}"
          formControlName="p2O5"
          data-test="proprietary-fertilizer-form__nutritionalComposition__p2O5"
        />
        <span matSuffix class="form-field-suffix--text">%</span>
      </mat-form-field>
    </div>
    <div>
      <mat-form-field>
        <mat-label>{{ 'nutritionalComposition.k2O' | translate }}</mat-label>
        <input
          matInput
          agrNumber
          [step]="0.001"
          placeholder="{{ 'nutritionalComposition.k2O' | translate }}"
          formControlName="k2O"
          data-test="proprietary-fertilizer-form__nutritionalComposition__k2O"
        />
        <span matSuffix class="form-field-suffix--text">%</span>
      </mat-form-field>
    </div>
    <div>
      <mat-form-field>
        <mat-label>{{ 'nutritionalComposition.na2O' | translate }}</mat-label>
        <input
          matInput
          agrNumber
          [step]="0.001"
          placeholder="{{ 'nutritionalComposition.na2O' | translate }}"
          formControlName="na2O"
          data-test="proprietary-fertilizer-form__nutritionalComposition__na2O"
        />
        <span matSuffix class="form-field-suffix--text">%</span>
      </mat-form-field>
    </div>
    <div>
      <mat-form-field>
        <mat-label>{{ 'nutritionalComposition.mgO' | translate }}</mat-label>
        <input
          matInput
          agrNumber
          [step]="0.001"
          placeholder="{{ 'nutritionalComposition.mgO' | translate }}"
          formControlName="mgO"
          data-test="proprietary-fertilizer-form__nutritionalComposition__mgO"
        />
        <span matSuffix class="form-field-suffix--text">%</span>
      </mat-form-field>
    </div>
    <div>
      <mat-form-field>
        <mat-label>{{ 'nutritionalComposition.caO' | translate }}</mat-label>
        <input
          matInput
          agrNumber
          [step]="0.001"
          placeholder="{{ 'nutritionalComposition.caO' | translate }}"
          formControlName="caO"
          data-test="proprietary-fertilizer-form__nutritionalComposition__caO"
        />
        <span matSuffix class="form-field-suffix--text">%</span>
      </mat-form-field>
    </div>
    <div>
      <mat-form-field>
        <mat-label>{{ 'nutritionalComposition.sO3' | translate }}</mat-label>
        <input
          matInput
          agrNumber
          [step]="0.001"
          placeholder="{{ 'nutritionalComposition.sO3' | translate }}"
          formControlName="sO3"
          data-test="proprietary-fertilizer-form__nutritionalComposition__so3"
        />
        <span matSuffix class="form-field-suffix--text">%</span>
      </mat-form-field>
    </div>
    <div>
      <mat-form-field>
        <mat-label>{{ 'nutritionalComposition.b' | translate }}</mat-label>
        <input
          matInput
          agrNumber
          [step]="0.001"
          placeholder="{{ 'nutritionalComposition.b' | translate }}"
          formControlName="b"
          data-test="proprietary-fertilizer-form__nutritionalComposition__b"
        />
        <span matSuffix class="form-field-suffix--text">%</span>
      </mat-form-field>
    </div>
    <div>
      <mat-form-field>
        <mat-label>{{ 'nutritionalComposition.mn' | translate }}</mat-label>
        <input
          matInput
          agrNumber
          [step]="0.001"
          placeholder="{{ 'nutritionalComposition.mn' | translate }}"
          formControlName="mn"
          data-test="proprietary-fertilizer-form__nutritionalComposition__mn"
        />
        <span matSuffix class="form-field-suffix--text">%</span>
      </mat-form-field>
    </div>
    <div>
      <mat-form-field>
        <mat-label>{{ 'nutritionalComposition.fe' | translate }}</mat-label>
        <input
          matInput
          agrNumber
          [step]="0.001"
          placeholder="{{ 'nutritionalComposition.fe' | translate }}"
          formControlName="fe"
          data-test="proprietary-fertilizer-form__nutritionalComposition__fe"
        />
        <span matSuffix class="form-field-suffix--text">%</span>
      </mat-form-field>
    </div>
    <div>
      <mat-form-field>
        <mat-label>{{ 'nutritionalComposition.zn' | translate }}</mat-label>
        <input
          matInput
          agrNumber
          [step]="0.001"
          placeholder="{{ 'nutritionalComposition.zn' | translate }}"
          formControlName="zn"
          data-test="proprietary-fertilizer-form__nutritionalComposition__zn"
        />
        <span matSuffix class="form-field-suffix--text">%</span>
      </mat-form-field>
    </div>
    <div>
      <mat-form-field>
        <mat-label>{{ 'nutritionalComposition.cu' | translate }}</mat-label>
        <input
          matInput
          agrNumber
          [step]="0.001"
          placeholder="{{ 'nutritionalComposition.cu' | translate }}"
          formControlName="cu"
          data-test="proprietary-fertilizer-form__nutritionalComposition__cu"
        />
        <span matSuffix class="form-field-suffix--text">%</span>
      </mat-form-field>
    </div>
    <div>
      <mat-form-field>
        <mat-label>{{ 'nutritionalComposition.co' | translate }}</mat-label>
        <input
          matInput
          agrNumber
          [step]="0.001"
          placeholder="{{ 'nutritionalComposition.co' | translate }}"
          formControlName="co"
          data-test="proprietary-fertilizer-form__nutritionalComposition__co"
        />
        <span matSuffix class="form-field-suffix--text">%</span>
      </mat-form-field>
    </div>
  </ng-container>
</agr-form-dialog>
